<template>
  <v-app>
    <v-system-bar
      app
      dark
      window
      color="red"
      height="20"
      class="justify-center font-weight-medium"
      v-if="enviroment.name == 'staging'">
      HOMOLOGAÇÃO
    </v-system-bar>
    <AppBar v-if="user && user.id" />

    <v-main > 
      <v-fade-transition hide-on-leave leave-absolute>
        <router-view v-if="user && user.id" />

        <v-container v-else fill-height fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <img src="@/assets/img/logo.png" class="logo" title="Logo" />

              <v-progress-circular
                indeterminate
                color="primary"
                class="d-flex mx-auto"></v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
      </v-fade-transition>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import enviroment from "@/assets/js/enviroment";
import AppBar from "./components/common/AppBar";

export default {
  name: "App",
  components: {
    AppBar,
  },
  data: () => ({
    enviroment: enviroment,
  }),

  computed: {
    ...mapGetters("auth", {
      user: "getMe",
    }),
  },
};
</script>

<style lang="scss">
.logo {
  height: 80px;
  margin-bottom: 16px;
  width: 80px;
}
</style>
